import { Box, Checkbox } from "@mui/material";
import UserPermission from "../common/UserPermission";
import {
  addPharmcyPermission,
  deletePharmcyPermission,
  getAllPharmacyPermission,
  getStaffPerById,
} from "../../features/staff/staffSlice";
import { useCallback, useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";

interface IProps {
  item: any;
}

const StaffPerissionEdit = ({ item }: IProps) => {
  const dispatch = useAppDispatch();
  const pharmacyId = localStorage?.getItem("pharmacyId");

  const {
    staffComponentPayload: { data: allComponents },
  }: any = useAppSelector((state) => state.staff);
  

  const authType: any = 2;
  const filterIndices = authType === 1 ? [2] : authType === 0 ? [11, 14] : [];
  const [staffPermission, setStaffPermission] = useState<any>([]);
  
  const getStaffPermissionsById = useCallback(() => {
    const obj: any = {
      staff_id: item?.id,
      pharmacy_id: pharmacyId,
    };
    dispatch(getStaffPerById(obj)).then((res: any) => {
      if (res?.payload?.success === true) {  
        const data = Array.isArray(res?.payload?.data) ? res.payload.data : [];
        setStaffPermission(data);
      } else {
        setStaffPermission([]);
      }
    });
  }, [dispatch, item?.id, pharmacyId]);

  const GetStaffPermissions = useCallback(() => {
    dispatch(getAllPharmacyPermission());
  }, [dispatch]);

  useEffect(() => {
    getStaffPermissionsById();
    GetStaffPermissions();
  }, [getStaffPermissionsById , GetStaffPermissions]);

  const displayTablePermissions = (
    column: any,
    module_name: any,
    permissions: Array<any>
  ) => {
    const existsInPermissions = permissions?.some(
      (item:any) => column ===  item.submodule
    );
    if (existsInPermissions) {
      const isChecked = staffPermission?.some((component: any) => {
        if (component.module_name === module_name) {
          return component.permissions.some(
            (permission: any) => permission.submodule === column
          );
        }
        return false;
      });
      const handleCheckboxChange = (e: any) => {
        if (isChecked) {
          handleDelete(module_name, column);
        } else {
          handleAdded(module_name, column);
        }
      };
      return (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <Checkbox
            style={{
              borderColor: "#0055AB",
              color: isChecked ? "#0055AB" : "#C4C4C4",
            }}
            checked={isChecked}
            onChange={handleCheckboxChange}
          />
        </Box>
      );
    } else {
      return null;
    }
  };

  const handleAdded = (module_name: string, submodule: string) => {
    const obj: any = {
      staff_id: item?.id,
      pharmacy_id: pharmacyId,
      permission: {
        module: module_name,
        submodule: submodule,
      },
    };

    dispatch(addPharmcyPermission(obj)).then((res) => {
      if (res.payload.success === true) {
        // After successful addition, re-fetch the staff permissions
        getStaffPermissionsById();
      }
    });
  };

  const handleDelete = (module_name: string, submodule: string) => {
    const obj: any = {
      staff_id: item?.id,
      pharmacy_id: pharmacyId,
      permission: {
        module: module_name,
        submodule: submodule,
      },
    };

    dispatch(deletePharmcyPermission(obj)).then((res) => {
      if (res.payload.success === true) {
        // After successful deletion, re-fetch the staff permissions
        getStaffPermissionsById();
      }
    });
  };

  return (
    <>
      <Box sx={{ mx: 2 }}>
        <UserPermission
          displayTablePermissions={displayTablePermissions}
          allComponentsData={allComponents}
        />
      </Box>
    </>
  );
};

export default StaffPerissionEdit;
